// useSubscription.js
// MODO ABIERTO — Sin Supabase, sin login, acceso ilimitado para el único usuario.
// El control de acceso al sitio ocurre a nivel de Cloudflare Access (Zero Trust)
// que verifica el email autorizado ANTES de que el request llegue a la app.
//
// Este hook mantiene la API original (canAnswerQuestion, canGenerateExam, etc.)
// para que el resto del código (App.js, Quiz.js, GenerateExam.js) no requiera
// modificaciones. Siempre devuelve "admin con plan pro ilimitado".

const MOCK_USER = {
  id: 'local-admin',
  email: 'alexisgc90@gmail.com',
  user_metadata: { full_name: 'Alexis' },
  app_metadata: { provider: 'cloudflare-access' },
};

const MOCK_SUBSCRIPTION = {
  active: true,
  plan: 'pro',
  isAdmin: true,
  limits: {
    questionsPerSession: Infinity,
    simulationsPerDay: Infinity,
  },
  usage: { questionsToday: 0 },
};

const noop = () => {};
const asyncNoop = async () => ({ error: null });

const useSubscription = () => {
  return {
    user: MOCK_USER,
    subscription: MOCK_SUBSCRIPTION,
    loading: false,
    canAnswerQuestion: () => ({ allowed: true }),
    canGenerateExam: () => ({ allowed: true }),
    canTakeSimulation: () => ({ allowed: true }),
    questionsRemaining: null,
    simulationsRemaining: null,
    trackQuestionAnswered: noop,
    showUpgradePrompt: false,
    refreshSubscription: asyncNoop,
    signOutCompletely: asyncNoop,
  };
};

export default useSubscription;
